import { combineReducers } from 'redux';
import appReducers from '../modules';
import globalFilterReducer from '../components/GlobalReduxFilters/reducer' 
 import regionReducer from '../components/GlobalContext/GlobalfiltersData';
import filterFieldsReducer from '../components/GlobalReduxFilters/FilterFields/reducerFilterFields';
import dateTimeReducer from '../components/DateTimeFilter/reducer';
import searchTextReducer from '../components/GlobalReduxFilters/searchReducer';
import subNodesReducer from '../components/InfraTopology/reducer'
import dashUnfilDReducer from '../components/Charts/reducer'
// import dashboardReducer from '../routes/Dashboard/dashboardData';
// import mapReducer from '../routes/DashboardMap/mapData';
// import siteviewReducer from '../routes/Site/SiteView/siteViewData';
// import RecommendationReducer from '../routes/Site/Recommendation/recommendationData';
// import networkElementReducer from '../routes/NetworkElements/networkElementsData';
// import dashboardConfigReducer from '../routes/Dashboard/DashboardConfig';
// import pceDashboardReducer from '../routes/PCE/pceDashboardData';
// import npsDashboardReducer from '../routes/NPSDashboard/npsDashboardData';
// import npsFilterConfigReducer from '../routes/NPSDashboard/npsFilterConfig';
// import emDashboardReducer from '../routes/EmDashboard/emDashoardConfig';
// import ClusterData from '../routes/Cluster/ClusterView/ClusterData';
// import mlDashboardReducer from '../routes/MLDashboard/mlDashboardData';
// import onDemandActuationReducer from '../routes/OnDemandActuation/onDemandActuationData';
// import truckRollReducer from '../routes/TruckRoll/truckRollData';
// import rollbackRecommendationReducer from '../routes/RollbackRecommendation/rollbackRecommendationData';
// import licenseKeyReducer from '../routes/LicenseKey/licenseKeyData';
// import npsDashboardV2Reducer from '../routes/NpsDashboardV2/npsDashboardData.v2';
// import eioDashboardReducer from '../routes/EioDashboard/data.js';
// import eioDashboardKpiReducer from '../routes/EioDashboard/dataKPI.js';
// import batteryAntonomyReducer from '../routes/BatteryAutonomy/BatteryAutonomyData.js';

// Add reducers created in routes folder here.
const appRoutesReducers = {
  regionReducer:regionReducer,
  globalFilterReducer:globalFilterReducer,
  filterFieldsReducer: filterFieldsReducer,
  dateTimeReducer: dateTimeReducer,
  subNodesReducer: subNodesReducer,
  searchTextReducer: searchTextReducer,
  dashUnfilDReducer: dashUnfilDReducer,
  // dashboard: dashboardReducer,
  // map: mapReducer,
  // siteview: siteviewReducer,
  // reco: RecommendationReducer,
  // networkElement: networkElementReducer,
  // dashboardConfig: dashboardConfigReducer,
  // pceDashboard: pceDashboardReducer,
  // npsDashboard: npsDashboardReducer,
  // npsFilterConfig: npsFilterConfigReducer,
  // emDashboard: emDashboardReducer,
  // Clusterview: ClusterData,
  // mlDashboard: mlDashboardReducer,
  // onDemandActuation: onDemandActuationReducer,
  // rollbackRecommendation: rollbackRecommendationReducer,
  // licenseKey: licenseKeyReducer,
  // truckRoll: truckRollReducer,
  // npsDashboardV2: npsDashboardV2Reducer,
  // eioDashboard: eioDashboardReducer,
  // eioDashboardKpi: eioDashboardKpiReducer,
  // batteryAntonomy: batteryAntonomyReducer,
};

const combinedReducers = combineReducers({
  ...appReducers,
  ...appRoutesReducers,
});

export default combinedReducers;
